
import { createReducer } from 'reducers';
import { Map, List } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { createStructuredSelector } from 'reselect';
import {
    SESSION_LOGOUT,
} from 'components/Session/SessionActionTypes';
import {
    REQUESTED,
    SUCCESSFUL,
    FAILED,
    UPDATE_FILTER,
    LOADING,
    SUCCESSFUL_POSTINGS,
    SUCCESSFUL_REQUESTS,
    UPDATE_CONTACTED,
    UPDATE_CONTACTEDLIST,
    UPDATE_IGNORELIST,
    UPDATE_WISHLIST,
    INIT,
    GET_TOTAL_COUNTS_SUCCESSFULL,
    GET_TOTAL_COUNTS_FAILED,
    GET_TOTAL_COUNTS_REQUESTED,
    // SYNC_DATA,
    // SYNC_FAILED,
    ADD_STUDENT_CURRENT_DIVISION,
    ADD_CURRENT_DIVISION_REQUESTED,
    REQUEST_VIEWED_COUNT_SUCCESSFUL,
    // ADD_CURRENT_DIVISION_FAILED,
} from './actionTypes';


export const initialState = Map({
  error: false,
  success: false,
  isRequested: false,
  isLoading: true,
  schools: [],
  postings: [],
  filter: {},
  requests: [],
  requestCount: 0,
  ignoreList: [],
  wishList: [],
  contactedList: [],
  contacted: [],
  totalCounts: {},
  totalCountsLoading: false,
  recommendedDivision: '',
  contactedCount: 0,
  // syncData: Map(),
  syncFailed: false,
  divisionAddRequested: false,
  requestViewedCount: 0,
  payload: Map(),
});
const isLoading = state => (state.requestCount - 1) === 0;

const getPostings = (postings) => {
  const allPostings = postings.toJS();
  return allPostings.sort((a, b) =>
    new Date(b.created_time) - new Date(a.created_time));
};

const handlers = {
  [INIT](state, action) {
    return state.merge({
      ignoreList: action.profile.get('sa_ignorelist'),
      wishList: action.profile.get('sa_wishlist'),
      contactedList: action.profile.get('sa_contactedlist'),
    });
  },
  [REQUESTED](state) {
    return state.merge({
      isRequested: true,
      error: false,
      success: false,
      requestCount: state.get('requestCount') + 1,
      isLoading: true,
      syncFailed: false,
      divisionAddRequested: false,
    });
  },
  [FAILED](state) {
    return state.merge({
      error: true,
      success: false,
      isRequested: false,
      requestCount: state.get('requestCount') - 1,
      isLoading: isLoading(state),
    });
  },
  [SUCCESSFUL](state, action) {
    let schools = state.get('schools');
    let recommendedDivision = state.get('recommendedDivision');
    schools = action.schools.get('results');
    if (action.schools.get('recommended_divisions') !== undefined) {
      const temp = action.schools.get('recommended_divisions');
      recommendedDivision = temp.get(0);
    }

    return state.merge({
      success: true,
      isRequested: false,
      error: false,
      schools,
      recommendedDivision,
      requestCount: state.get('requestCount') - 1,
      isLoading: isLoading(state),
      contactedCount: 0,
    });
  },
  [SUCCESSFUL_POSTINGS](state, action) {
    let postings = state.get('postings');
    postings = action.postings.get('results');
    return state.merge({
      success: true,
      isRequested: false,
      error: false,
      postings: getPostings(postings),
      requestCount: state.get('requestCount') - 1,
      postingLoader: false,
    });
  },
  [SUCCESSFUL_REQUESTS](state, action) {
    const data = action.requests;
    let contacted = [];
    let requests = [];
    if (data && data.size > 0) {
      contacted = data.get(1).get('from_profile_id');
      requests = data.get(0).get('to_profile_id');
    }


    return state.merge({
      success: true,
      isRequested: false,
      error: false,
      requests,
      contacted,
      requestCount: state.get('requestCount') - 1,
      // isLoading: isLoading(state),
    });
  },
  [UPDATE_CONTACTEDLIST](state, action) {
    return state.merge({
      contactedList: action.list,
      contactedCount: state.get('contactedCount') + 1,
    });
  },
  [UPDATE_IGNORELIST](state, action) {
    return state.merge({
      ignoreList: action.list,
    });
  },
  [UPDATE_WISHLIST](state, action) {
    return state.merge({
      wishList: action.list,
    });
  },
  [UPDATE_CONTACTED](state, action) {
    let list = List();
    if (List.isList(action.request)) {
      list = state.get('contacted').merge(action.request);
    } else {
      list = state.get('contacted').push(action.request);
    }
    return state.merge({
      contacted: list,
    });
  },
  [UPDATE_FILTER](state, action) {
    return state.merge({
      filter: action.filter,
    });
  },
  [LOADING](state) {
    return state.merge({
      requestCount: state.get('requestCount') - 1,
      isLoading: isLoading(state),
    });
  },
  [GET_TOTAL_COUNTS_REQUESTED](state) {
    return state.merge({
      totalCountsLoading: true,
    });
  },
  [GET_TOTAL_COUNTS_FAILED](state) {
    return state.merge({
      totalCountsLoading: false,
    });
  },
  [GET_TOTAL_COUNTS_SUCCESSFULL](state, action) {
    return state.merge({
      totalCounts: action.data,
      totalCountsLoading: false,
    });
  },
  /* [SYNC_DATA](state, action) {
    return state.merge({
      syncData: action.syncData,
    });
  },
  [SYNC_FAILED](state) {
    return state.merge({
      syncFailed: true,
    });
  }, */
  [ADD_STUDENT_CURRENT_DIVISION](state) {
    return state.merge({
      currentDivisionAdded: true,
    });
  },
  [ADD_CURRENT_DIVISION_REQUESTED](state) {
    return state.merge({
      divisionAddRequested: true,
    });
  },
  [REQUEST_VIEWED_COUNT_SUCCESSFUL](state, action) {
    return state.merge({
      requestViewedCount: action.data.counts,
    });
  },
  // [ADD_CURRENT_DIVISION_FAILED](state) {
  //   return state.merge({
  //     divisionAddRequested: false,
  //   });
  // },
  [SESSION_LOGOUT](state) {
    return state.merge({
      error: false,
      success: false,
      isRequested: false,
      isLoading: true,
      schools: [],
      postings: [],
      filter: {},
      requests: [],
      requestCount: 0,
    });
  },
};


export const dashboard = createReducer(initialState, handlers);

// LOGIN SELECTOR
const getError = state => state.dashboard.get('error');
const getSuccess = state => state.dashboard.get('session');
const getIsRequested = state => state.dashboard.get('isRequested');
const schools = state => state.dashboard.get('schools');
const filter = state => state.dashboard.get('filter');
const postings = state => state.dashboard.get('postings');
const requests = state => state.dashboard.get('requests');
const contacted = state => state.dashboard.get('contacted');
const getRequestCount = state => state.dashboard.get('requestCount');
const loading = state => state.dashboard.get('isLoading');
const wishList = state => state.dashboard.get('wishList');
const ignoreList = state => state.dashboard.get('ignoreList');
const contactedList = state => state.dashboard.get('contactedList');
const gettotalCountsLoading = state => state.dashboard.get('totalCountsLoading');
const getTotalCounts = state => state.dashboard.get('totalCounts');
const getRecommendedDivision = state => state.dashboard.get('recommendedDivision');
const getContactedCount = state => state.dashboard.get('contactedCount');
// const syncData = state => state.dashboard.get('syncData');
const syncFailed = state => state.dashboard.get('syncFailed');
const divisionAddRequested = state => state.dashboard.get('divisionAddRequested');
const requestViewedCount = state => state.dashboard.get('requestViewedCount');

export const selector = createStructuredSelector({
  error: getError,
  success: getSuccess,
  isRequested: getIsRequested,
  schools,
  filter,
  postings,
  requests,
  isLoading: loading,
  wishList,
  contactedList,
  ignoreList,
  contacted,
  totalCounts: getTotalCounts,
  totalCountsLoading: gettotalCountsLoading,
  requestCount: getRequestCount,
  recommendedDivision: getRecommendedDivision,
  contactedCount: getContactedCount,
  // syncData,
  syncFailed,
  divisionAddRequested,
  requestViewedCount,
});



// WEBPACK FOOTER //
// ./src/components/DashboardView/redux.js